import { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { ToggleRight } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Card } from "@/components/ranger/PageHeader";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export const FeatureSwitches = ({ cid }) => {
  const { can } = useAuth();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/communities/${cid}/features`).then((r) => setRows(r.data)).catch(() => {}); }, [cid]);
  const flip = async (key, enabled) => {
    try { const { data } = await api.put(`/communities/${cid}/features`, { [key]: enabled }); setRows(data); toast.success(`${data.find((r) => r.key === key).label} ${enabled ? "on" : "off"}`); } catch (e) { toast.error(errMsg(e)); }
  };
  const groups = useMemo(() => [...new Set(rows.map((r) => r.group))], [rows]);
  return (
    <Card title="Feature switches" icon={ToggleRight} testId="features-card" className="mb-5">
      <p className="mb-4 text-xs text-slate-500">Turn whole features on or off for this server. Each switch is the same setting as on its own page. Items marked "unverified" use RCON commands you should test on the Live Console first.</p>
      <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4">{groups.map((g) => (
        <div key={g}>
          <div className="rg-label mb-2">{g}</div>
          <ul className="space-y-1.5">{rows.filter((r) => r.group === g).map((r) => (
            <li key={r.key} className="flex items-center justify-between gap-3 rounded-sm border border-[#1E2D4A] px-3 py-2">
              <span className="text-sm text-slate-200">{r.label}{r.unverified && <span className="ml-2 font-mono text-[10px] uppercase text-amber-400">unverified</span>}</span>
              <Switch data-testid={`feature-${r.key}`} checked={r.enabled} disabled={!can("admin")} onCheckedChange={(v) => flip(r.key, v)} />
            </li>
          ))}</ul>
        </div>
      ))}</div>
    </Card>
  );
};
